<template>
<div class="chapter">
<div class="inner_page">
<div id="Chapter-One.html" xml:lang="en-US">
<div class="Basic-Text-Frame-19">
<p class="ch"><a id="Anchor-1"></a>CHAPTER ONE</p>
<p class="body-text-opening"><span class="sc" xml:lang="en-US">T</span><span class="sc-epub" xml:lang="en-US">HIS</span><span class="sc" xml:lang="en-US"> </span><span class="sc-epub" xml:lang="en-US">MADE</span><span class="sc" xml:lang="en-US"> </span><span class="sc-epub" xml:lang="en-US">IT</span><span class="sc" xml:lang="en-US"> </span><span class="sc-epub" xml:lang="en-US">OFFICIAL</span><span class="sc" xml:lang="en-US">:</span>
					Grace Barrett’s life was over. Or, at the very least, it was so irrevocably
					screwed up that a quick death would be a blessing at this point.</p>
<p class="body-text">She was twenty-eight, in debt to an angry ex-boyfriend, she had
					exactly $37.40, and she was <em class="italic">here.</em></p>
<p class="body-text">In Wyoming.</p>
<p class="body-text">Well, she’d been in Wyoming for hours, actually. Hours of
					endless beige hills and barren mountains. Hours of cows. And sheep. And some
					strange creature she’d thought was a deer until she’d gotten a better look. Deer
					didn’t look as if they had exotic black masks painted on their little faces.
					What the heck were those things?</p>
<p class="body-text">Grace shuddered a little as she stepped out of the bus. Her
					feet touched the ground and there was no taking it back now. She really was in
					Wyoming. She was standing on it.</p>
<p class="body-text">“Damn,” she muttered.</p>
<p class="body-text">The elderly man in front of her turned with a concerned smile.
					“Sorry, ma’am?”</p>
<p class="body-text">Grace crossed her arms in defense. “Sorry about that. I was
					just…”</p>
<p class="body-text">He smiled and put a hand to his balding head as if he meant to
					tip a hat. “Beg pardon.”</p>
<p class="body-text">No one had ever begged her pardon before. Grace crossed her
					arms more tightly, unsure how to handle this situation. Thankfully, the man
					moved away before she was forced to respond.</p>
<p class="body-text">Grace glanced warily around. After her years in L.A., she knew
					to keep her guard up against anyone who approached her on the street, no matter
					how kind and polite the people here might seem. Nobody did, so she edged toward
					the driver as he unlocked the luggage compartments of the bus. She was used to
					being alone, but she’d been surrounded by people on this bus for nearly two
					days. She felt almost panicked with the need to be free.</p>
<p class="body-text">The driver began unloading the bags, laying them out in neat
					rows. Grace kept a sharp eye on his hands, waiting for her ancient camouflage
					duffel bag to appear.</p>
<p class="body-text">No one else seemed to be watching as closely. The other
					passengers were hugging friends and family or idly chatting with each other as
					their eyes traveled along the horizon. She spared only the barest of glances
					toward the view of the mountains. Someone could walk up and grab a bag and be
					gone before anybody even noticed.</p>
<p class="body-text">These folks were obviously not from L.A. Or…maybe their bags
					didn’t contain every ridiculous, precious thing in the world that belonged to
					them. Maybe their bags were just filled with dirty clothes and cheap souvenirs
					from a beach vacation. But when Grace’s bag appeared and was set on the ground,
					she jumped forward and dragged it away like a feral animal with a piece of
					precious meat. It was nearly too heavy for her to lift, but she’d have to find a
					way. She had no car, no spare money for a taxi—if they had such things here—and
					she hadn’t told her great-aunt when she’d be arriving. So she was hoofing
					it.</p>
<p class="body-text">“Hoofing it,” she breathed, managing a laugh as she glanced
					around to see if there were any cows standing next to her. Unlike the rest of
					Wyoming, the town of Jackson seemed to be blessedly cow-free. It was also
					slightly larger than she’d expected, dashing her hope that she could simply
					wander down the main street until she spotted the address she was looking for.
					She’d have to ask for help. The idea made her grimace as she took a deep breath
					and looked around. Maybe she could just find a free map.</p>
<p class="body-text">“Bingo,” she muttered as her eye fell on a big sign that
					spelled out <em class="italic">Jackson Hole Information!</em> in old-timey
					wooden letters. Grace had lived in Hollywood a long time. If there was one thing
					she knew, it was how to work a tourist trap.</p>
<p class="body-text">She dragged her bag across the asphalt and onto the
					wooden…sidewalk? Grace blinked and looked down the street, then turned to look
					in the other direction. Yes, as far as the eye could see, the sidewalks were
					wooden, like an Old West town.</p>
<p class="body-text">“Wow,” she muttered. These people were really trying hard, even
					if she had to admit that it was cute. Shaking her head, she pulled her bag down
					the sidewalk until she got to the brochure stand.</p>
<p class="body-text">“Do you have a free map of the area?” she asked the matronly
					woman who’d turned away to straighten papers.</p>
<p class="body-text">“Oh, hello!” the woman called as she spun around. “Good
					afternoon!”</p>
<p class="body-text">“Hi. Um. I just need a map of the town. Something simple.”</p>
<p class="body-text">The woman’s eyes flicked up to Grace’s hair for a moment, and
					Grace wondered what she must think of a purple-haired girl in combat boots
					asking about Jackson, but the woman’s smile didn’t waver. “Well, I won’t lie.
					There are a lot of choices. Here’s the official town map.” She laid out a folded
					brochure. “But—and don’t tell anyone I said this—I actually like the one the
					restaurant association puts out a little better.”</p>
<p class="body-text">“Thanks.” Grace took both the brochures and opened the one the
					woman had recommended.</p>
<p class="body-text">“What are you looking for, sweetheart?”</p>
<p class="body-text">Sweetheart? Grace glanced down at her T-shirt. Yep. It still
					advertised an old L.A. burlesque club. “Just a street,” she said softly, hoping
					not to invite more questions.</p>
<p class="body-text">“Which street?”</p>
<p class="body-text">Grace cleared her throat and shifted, her gaze desperately
					boring into the map, hoping she could just find it herself. “Um, Sagebrush.”</p>
<p class="body-text">“Sagebrush. That’s a long one. What’s the address?” The woman’s
					pink fingernail pointed toward the map, but it moved before Grace could register
					which street she was pointing to.</p>
<p class="body-text">“Six-O-five West Sagebrush,” she said, sighing.</p>
<p class="body-text">“Oh, that’s way over here!” The woman pointed again, and this
					time Grace saw it. A long line that meandered all the way through town and then
					followed the curve of a stream before it ended. It looked like quite a haul.</p>
<p class="body-text">“Thank you,” Grace said. She folded the map and hefted her bag
					up, biting back a grunt as she worked the strap over her shoulder. “This way?”
					She tilted her head in the direction she thought she needed to go. She’d always
					been pretty good with that sort of thing.</p>
<p class="body-text">“Yep!”</p>
<p class="body-text">Grace took a deep breath and started walking. Her boots clomped
					on the wood.</p>
<p class="body-text">“Oh, honey!”</p>
<p class="body-text">Grace pretended she didn’t hear.</p>
<p class="body-text">“Sweetie, stop! You can’t walk all that way.”</p>
<p class="body-text">“I’m fine,” she called.</p>
<p class="body-text">“But there’s a free bus!”</p>
<p class="body-text">Her boots stopped clomping. “Free?”</p>
<p class="body-text">“Totally free. In fact, it’ll stop right here in a few minutes.
					Comes every half hour.”</p>
<p class="body-text">Grace turned back and eyed the woman suspiciously. “Will I have
					to go tour a new condo complex or something?”</p>
<p class="body-text">“What? Oh, heavens no. It’s the town bus. It’ll stop just a few
					blocks from where you’re going. Six-O-five West Sagebrush. That’s the Stud Farm,
					isn’t it?”</p>
<p class="body-text">“The what?” She dropped the bag. She’d heard tales that her
					great-aunt was a crazy old lady, but… <em class="italic">“What?”</em></p>
<p class="body-text">“Oh, never mind me.” The woman laughed. “That’s just a silly
					local nickname.”</p>
<p class="body-text">“For <em class="italic">what?</em>”</p>
<p class="body-text">“The building.”</p>
<p class="body-text">Just as Grace was opening her mouth to demand a real answer, a
					hiss of brakes sounded from the curb. The bus had arrived, and she didn’t have
					time to get more information. She hauled up her bag, wrestled it onto her
					shoulder and jogged for the bus. As promised, there didn’t seem to be a fee. The
					driver glanced at her impatiently, and she felt a small jolt of comfort at that.
					The bus might be free, but the driver was just as jaded as every bus driver in
					L.A.</p>
<p class="body-text">Slightly less suspicious, Grace took a seat close to the front
					so she wouldn’t have to haul the bag any farther, then dug the map back out to
					see which intersection she was looking for.</p>
<p class="body-text">A few blocks later, the wooden walkways were replaced with
					cement, and the two-story buildings with front porches became less common. By
					the time they reached the right intersection, they’d passed a strip mall and a
					big grocery store. She felt slightly less disoriented as she grabbed the
					bellpull and hauled her bag down the steps.</p>
<p class="body-text">She didn’t dare stop and look around as the bus pulled away.
					Her shoulders were already aching and the bag wasn’t getting any lighter, so she
					set off down the side street with her head down. Sagebrush was only four blocks
					down. No problem.</p>
<p class="body-text">By the time she reached the next street, she was gasping for
					air. “Good Lord,” she muttered, stopping to take a few deep breaths. It didn’t
					help. Altitude, she reminded herself, finally giving in and setting the bag
					down. Closing her eyes, she concentrated on oxygen, and without the weight of
					the bag, she was breathing normally within a few moments.</p>
<p class="body-text">Had she really thought she was going to walk all the way from
					the bus station to the apartment? Laughing at the image of herself crawling down
					the street with the bag balanced on her back, Grace opened her eyes and took a
					deeper breath.</p>
<p class="body-text">“Mmm,” she hummed. The air smelled…nice. Really nice. Crisp and
					fresh and clean. Maybe she could live with less oxygen. Just for a little while.
					It wasn’t like she was going to stay in this ridiculous little town.</p>
<p class="body-text">It was cute, though. The Old West part of town had morphed into
					a slightly Victorian feel. Little gingerbread houses, separated by the
					occasional 1960s ranch house. Grace had never lived in a small town before.
					Maybe it would be okay, temporarily.</p>
<p class="body-text">As if to show her just how wrong she was, the jingle of a bike
					bell interrupted her thoughts. A bicycle passed by. An honest-to-goodness
					bicycle built for two. Both riders waved as they rode away. Grace grimaced at
					what looked like an advertisement for happiness. This town was going to rub her
					own misery in her face.</p>
<p class="body-text">Once the bike had passed, she lifted the bag and trudged on.
					Another bike appeared, this one with only one rider, but with an old-fashioned
					bike horn that the rider honked before he waved. Yeah, L.A. was bad enough with
					all the sunshine, but this town was just too much.</p>
<p class="body-text">Vancouver would be better, hopefully. There was a big enough
					movie industry there. She had a job waiting for her if she could get there in
					six weeks. And if she did a good job, maybe she could get steady work as a
					makeup artist up there where nobody knew she was difficult to work with. <em class="italic">Difficult,</em> as in she wouldn’t put up with handsy
					actors or abusive bosses. That seemed totally reasonable to her, but in L.A.,
					ass kissing was a way of life.</p>
<p class="body-text">Grace turned onto Sagebrush and started watching the
					addresses.</p>
<p class="body-text">When she finally spotted number 605, she was pleasantly
					surprised. The Victorian building didn’t look like it had anything to do with a
					farm. Or studs. It wasn’t the prettiest house on the block, but the paint was
					fresh and bright royal-blue. The trim around the windows and the porch was vivid
					white. The place looked perfectly respectable.</p>
<p class="body-text">Then her eyes slid to the building next door.</p>
<p class="body-text">The <em class="italic">saloon</em> next door.</p>
<p class="body-text">She knew it was a saloon because of the wide plank of wood over
					the door that screamed SALOON in big black letters. Barstools lined the ancient
					porch and, unlike the building Grace was standing in front of, this place looked
					as though it hadn’t been painted since 1902. In fact, it looked like a <em class="italic">barn</em> that hadn’t been painted since 1902. She was
					pretty sure that was some sort of hayloft door near the roof.</p>
<p class="body-text">Grace’s shoulders were protesting the delay, so she adjusted
					the bag’s strap and walked up the sidewalk to the house. As soon as she stepped
					in, she saw two doors marked A and B. The only other possible route was a wide
					staircase that led to the second floor. Grace dropped the bag and dug out the
					letter from her great-aunt, praying that her apartment was on the ground floor.
					She wasn’t sure she could make it up the stairs without passing out.</p>
<p class="body-text">“Apartment A,” she breathed. “Thank God.”</p>
<p class="body-text">She was reaching for the door when she realized the mistake and
					paused. She didn’t have a key. And—she looked at the letter again—her aunt
					hadn’t given a phone number.</p>
<p class="body-text">Feeling stupid for even trying, she reached for the knob and
					tested it. It didn’t budge, of course. Who would leave a vacant apartment
					unlocked?</p>
<p class="body-text">“Crap.”</p>
<p class="body-text">Grace stood on her tiptoes and ran her fingers above the door
					frame. Nothing.</p>
<p class="body-text">“Shit.”</p>
<p class="body-text">When she looked down, she saw that her black boots were planted
					right in the middle of a doormat that said Howdy! inside a circled lasso. Her
					last hope was this rectangle of Western kitsch. Holding her breath, she stepped
					off and picked it up. Nothing.</p>
<p class="body-text">“Damn it,” she groaned, letting her lungs empty on a growl of
					frustration as she glared down at the envelope in her hand. Her aunt’s return
					address was a P.O. box. She’d communicated only via letter to the friend’s
					address that Grace had used for return mail. And Grandma Rose never answered her
					cell phone.</p>
<p class="body-text">On the off chance that it was the one time of day that her
					grandmother turned her cell on to check messages, Grace pulled out her crappy
					pay-as-you-go phone and dialed Grandma’s number. A few seconds later, Grace
					heard the beep of the voice-mail message starting, and her heart dropped.
					However Grandma eventually went, it wasn’t going to be from “radio wave brain
					cancer,” at least according to her.</p>
<p class="body-text">Grace looked back to the letter in her hand, feeling hopeless.
					What was she going to do? Wander around town asking everyone if they knew her
					aunt? She’d been on a bus for two days. She’d thought she was about to get a
					break. Just a few hours to rest and let her guard down.</p>
<p class="body-text">“Damn it, damn it, damn it!” She hauled back one boot and
					kicked her bag as hard as she could. It wasn’t hard enough. She pulled back her
					foot to do it again. The bag held everything she owned in the world, but right
					now, that seemed like the perfect reason to kick it. This was her life. Right
					here. Her whole crappy life in this beat-up, dirty camouflage bag.</p>
<p class="body-text">“Damn it!” she screamed one more time as she kicked it hard
					enough to slide it six inches across the floor.</p>
<p class="body-text">“That bag must’ve done something really shitty to get a little
					thing like you all riled up.”</p>
<p class="body-text">Grace stomped her foot onto the floor and spun to face the low
					drawl, her heart slamming into a crazed beat. A man stood in the doorway of the
					other apartment. He leaned against the doorjamb, arms crossed and mouth turned
					up in an amused smile.</p>
<p class="body-text">“Excuse me?” she snapped.</p>
<p class="body-text">“Just wondering why you’re kicking the tar out of that bag,
					darlin’.”</p>
<p class="body-text">“First of all, I’m not your darlin’. Second, it’s none of your
					business.”</p>
<p class="body-text">His smile widened, revealing dimples in his tanned face. His
					tanned, granite-jawed, handsome face. “Really? None of my business? When a
					crazed banshee of a woman stands on my doorstep cursing her heart out on a
					beautiful Friday afternoon? Tends to pique my interest.”</p>
<p class="body-text">“It’s my doorstep,” she corrected, hoping she was right. Hoping
					her aunt hadn’t decided to lease the apartment to somebody else in the week
					since she’d written.</p>
<p class="body-text">His eyebrows shot up, and the man pushed up to his full height.
						“<em class="italic">Your</em> doorstep? Are you sure?”</p>
<p class="body-text">Grace went for bravado and snorted. “Of course I’m sure.”</p>
<p class="body-text">He shrugged one wide shoulder, and Grace was suddenly very
					aware that his plaid button-down shirt wasn’t actually buttoned down. It looked
					as though he’d just shrugged it on to come investigate the commotion in the
					hall, and when he moved, a long strip of skin showed from his neck all the way
					down to his waist. And then there were his jeans and the affectionate way they
					clung to strong thighs.</p>
<p class="body-text">The Stud Farm, she suddenly remembered. What kind of place was
					this?</p>
<p class="body-text">She shook off her thoughts. The man was wearing cowboy boots,
					for godssake. He was wholesome and homey. His thighs were none of her concern.
					But the sight of his boots reminded her that she was in Wyoming, which reminded
					her why she was in Wyoming and what a mess she’d made of her life. “Anyway,” she
					said with a scowl, “still none of your business.”</p>
<p class="body-text">She grabbed the handle of her duffel bag and pulled it up with
					shaky arms. She couldn’t leave her bag here, but she didn’t know what she was
					going to do with it. She didn’t know what she was going to do with <em class="italic">herself.</em></p>
<p class="body-text">A surge of anger gave her the strength to bounce the bag higher
					in her grip, but she wasn’t going to make it to the curb, much less walk to…
					Where, exactly?</p>
<p class="body-text">“Let me get that.” A large hand closed over the handle and
					lifted the weight from her grasp.</p>
<p class="body-text">“Hey—” she started, but he’d already transferred the bag to his
					possession. He held it with one hand as if it were a pocketbook. Even more skin
					showed past his shirt now. Skin and muscle and golden hair.</p>
<p class="body-text">While she was staring, he reached past her and opened the
					door.</p>
<p class="body-text">He just…opened the door.</p>
<p class="body-text">“What the hell?” she bit out.</p>
<p class="body-text">He shot her a puzzled look. “You did say it was your place,
					right?”</p>
<p class="body-text">“Yes, but…” She felt like smoke was about to come out her ears,
					and wanted to snatch her bag away and tell him to get lost. But her arms were so
					tired. “The door was locked,” she said past clenched teeth.</p>
<p class="body-text">“It sticks a little. You have to pull back on it before you
					turn the knob.”</p>
<p class="body-text">“So it was just open? Unlocked?”</p>
<p class="body-text">“Nothing to steal here,” he said, gesturing with his free hand.
					“Where do you want this?”</p>
<p class="body-text">Where, indeed? Now that they were inside, the apartment looked
					like an old converted place she’d once rented in L.A. White walls, scuffed
					wooden floors, a nondescript kitchen. But with little touches from the past,
					like a fireplace and built-in bookshelves. And not one single piece of
					furniture.</p>
<p class="body-text">Somehow that hadn’t occurred to her.</p>
<p class="body-text">“Right there is fine,” she murmured. “Thanks.” It didn’t really
					matter, after all. Living room, bedroom. They were equally empty rooms to
					her.</p>
<p class="body-text">“Here?” the guy asked doubtfully.</p>
<p class="body-text">“Yes, there. Thank you. I appreciate the help.”</p>
<p class="body-text">“Yeah?” He smiled wide enough to show his dimples again. “Then
					why did you look like those words hurt coming out?”</p>
<p class="body-text">She tried frowning at him, but he just stuck out his hand.</p>
<p class="body-text">“I’m Cole, by the way. Cole Rawlins.”</p>
<p class="body-text">“Grace Barrett,” she said. His wide hand engulfed hers, and
					though he didn’t squeeze hard, there was no mistaking the strength in those
					rugged hands. His calluses rasped against her fingers.</p>
<p class="body-text">“Grace,” he murmured, his gaze rising momentarily to her
					hair.</p>
<p class="body-text">“Yes. Grace.” She enjoyed the contradiction of her traditional,
					gentle name and her physical appearance.</p>
<p class="body-text">This man recovered more quickly than most. “A pleasure,” he
					said simply. Then added, “Grace.”</p>
<p class="body-text">She pulled her hand away at the intimacy of hearing him say her
					name as if it truly were a pleasure.</p>
<p class="body-text"><em class="italic">Cowboy freak.</em> Though her hand
					tingled and she tried not to smile.</p>
<p class="body-text">“You’re not from around here.” The understatement of the
					year.</p>
<p class="body-text">“Look, I really do appreciate the help, but I need to find my
					aunt, so…” <em class="italic">Give me some space?</em></p>
<p class="body-text">He didn’t seem to hear that last, unspoken part of the
					conversation. “Your aunt?”</p>
<p class="body-text">“I’m renting the apartment from her.”</p>
<p class="body-text">“Wait a minute. Old Rayleen is your aunt?”</p>
<p class="body-text">“My great-aunt, actually.”</p>
<p class="body-text">“Ah. I get it, then.”</p>
<p class="body-text">“Get what?” she asked.</p>
<p class="body-text">“Why she’d rent this place to you.”</p>
<p class="body-text">Grace straightened her shoulders and scowled. “Why exactly
					wouldn’t she rent this place to me, huh? Real nice, cowboy.”</p>
<p class="body-text">She assumed he would stammer and shift and try to find some
					excuse, when what he really meant was that she didn’t look like a girl who
					belonged here. But instead of clearing his throat or changing the subject, he
					just grinned again.</p>
<p class="body-text">“Let’s just say you’re a little smaller than the other renters
					here.”</p>
<p class="body-text">Grace glanced around as if those other renters had just joined
					them. “I thought you Wyoming folk were supposed to be plainspoken. How about you
					try saying what you mean?”</p>
<p class="body-text">“Talk about plainspoken. They don’t make ’em timid where you
					come from, do they? All right, here’s the deal. Your aunt has a reputation for
					renting only to men. Says that they’re easier to deal with.” The wry tone of his
					voice implied something different.</p>
<p class="body-text">“Uh, is there something going on here I should know about?”
					When she shot an obvious look down his body, his eyes widened in horror.</p>
<p class="body-text">“No! Absolutely not. But, hey, if she likes my face enough to
					give me a hundred-dollar discount on rent, I won’t argue with her. But that’s
					the extent of her quirkiness. I swear.”</p>
<p class="body-text">Even the most cynical person could tell he was offering the
					truth. And his face? Hell, that was enough to inspire generosity. It was lovely
					in a very masculine way. A jaw like steel. Strong nose. And blue eyes that
					crinkled with warmth fairly often, if the laugh lines were any indication. And
					his short brown hair had just enough wave to make it look unruly and disheveled.
					He was gorgeous, and his body called for further attention, too, but Grace kept
					her eyes on his face.</p>
<p class="body-text">“Isn’t it illegal to rent only to men?”</p>
<p class="body-text">“Beats me. But I guess she gets away with it.”</p>
<p class="body-text">“Regardless,” she finally said, “I need to find my aunt. Get a
					key. Let her know I’m here.”</p>
<p class="body-text">“Well, that’s easy. She’s probably next door.”</p>
<p class="body-text">“At your place?”</p>
<p class="body-text">“No! Come on. I meant next door at the saloon.”</p>
<p class="body-text">“Is she a big drinker?”</p>
<p class="body-text">“She runs the place,” he corrected. “And she’s a big
					drinker.”</p>
<p class="body-text">“Got it. Thanks. I’ll just go see her then.” She was clearly
					implying he should leave. She even raised an impatient eyebrow and glanced
					toward the door. But Cole didn’t notice because he was pointedly looking around
					her apartment.</p>
<p class="body-text">“You got some furniture coming?”</p>
<p class="body-text">“Sure. Of course. Thanks for the help.”</p>
<p class="body-text">He turned his grin on her again. “All right, then, Grace
					Barrett. Even cowboys can take a hint when you’re bashing them over the head
					with it. But let me know if you need any more help. I’m only a few feet
					away.”</p>
<p class="body-text">“Great. Thanks.”</p>
<p class="body-text">The sound of his boots on the wood floor of the apartment was
					softer than Grace would’ve expected, but his steps still echoed against the bare
					walls. If she were the kind of person who had ever planned to stay in one place
					more than six months, Grace knew what she would be thinking at this moment.
						<em class="italic">I’ll need to find something to put on these
						walls.</em> Or at the very least, she would’ve been painting them some
					warm and inviting color in her mind, and wondering where she could find some
					rugs. Instead, she just took pleasure in the fact that the white paint was still
					white and was marred by only a few nail holes.</p>
<p class="body-text">At least she’d learned to appreciate the small things in life.
					And the big things, like the sound of the door closing behind Cole Rawlins as he
					finally left her alone.</p>
<p class="body-text">“Whew,” Grace breathed, letting the air ease out of her lungs.
					The place felt a lot bigger without him taking up all her space.</p>
<p class="body-text">Okay, maybe a little too big. But without him here, she could
					see the small ways that the apartment wasn’t quite like an old place in L.A. The
					beautiful, dark wood window frame hadn’t been painted over, and instead of
					miniblinds, there were white curtains. It also didn’t smell like roach
					spray.</p>
<p class="body-text">She strolled over to the window and pulled aside the curtains.
					Here was another difference. Instead of a view of a parking lot or traffic or a
					million other apartments, Grace was looking at a huge pine tree. Past that, she
					had a view of the small street, and a green house with a yellow porch on the
					other side of it. A snowmobile sat in the open garage.</p>
<p class="body-text">Grace crinkled her nose at the strangeness of the sight. That
					was something she’d never seen in L.A. Jet Skis, sure. But the snowmobile looked
					like a real machine. It looked dangerous and powerful, gleaming black and red in
					the sunlight. It looked…fun.</p>
<p class="body-text">Too bad she’d be long gone by winter. She had to get to
					Vancouver in six weeks and make some money, or she was going to be in even
					bigger trouble than she was now. Way bigger.</p>
<p class="tb">* * *</p>
<p class="body-text-no-tab"><span class="sc" xml:lang="en-US">C</span><span class="sc-epub" xml:lang="en-US">OLE</span><span class="sc" xml:lang="en-US"> </span><span class="sc-epub" xml:lang="en-US">GRABBED</span><span class="sc" xml:lang="en-US"> </span><span class="sc-epub" xml:lang="en-US">A</span><span class="sc" xml:lang="en-US"> C</span><span class="sc-epub" xml:lang="en-US">OKE</span> and leaned against the kitchen counter, eyes on
					his front door. That had been a surprise. Opening his door to find a raging
					tornado of a city girl assaulting a stuffed duffel bag. Not at all what he’d
					expected during his quick run home to shower and grab a sandwich after his half
					day at the ranch.</p>
<p class="body-text">The female voice in the hallway had caught his attention. The
					female herself, spewing curses and kicking things? Whew.</p>
<p class="body-text">That girl was going to be trouble. If the purple layers in her
					dark, choppy hair didn’t make that clear, the hard glint in her eyes certainly
					did. He knew that look. He’d seen it before. And despite his image as the
					wholesome and friendly good ol’ cowboy, that look stirred something in him. It
					was like a dare. A challenge.</p>
<p class="body-text">And he did love a challenge.</p>
<p class="body-text">Speaking of… She’d basically pushed him out the door, claiming
					that she needed to find her aunt right away. But five minutes had passed and he
					still hadn’t heard her leave. Rude little witch. It seemed like she’d taken his
					attempts to help as some sort of insult.</p>
<p class="body-text">He should’ve let her stand out in that hallway all afternoon,
					trying to figure out how to get into an open apartment.</p>
<p class="body-text">Cole imagined her increasing anger and frustration. That look
					of hot rage he’d glimpsed when he’d opened his door to find out what the noise
					was about. She hadn’t even been embarrassed. She’d just glared at him as if he
					was intruding.</p>
<p class="body-text">“Trouble,” he murmured as he finally gave up his vigil and
					stood. Shane was waiting at the saloon to grab a beer, and Cole had nothing to
					do until physical therapy the next day. He managed not to linger in the
					entryway, but only because he figured he might see her at the Crooked R
					soon.</p>
<p class="body-text">He’d forgotten about this type of girl during the past decade.
					But he was remembering everything now. The way they made his heart beat faster.
					The way they seemed to dare him to act on his impulses. He’d once had a thing
					for dangerous city girls. And he’d ended up in a bad way because of it.</p>
<p class="body-text">He shoved the thought away as he walked into the saloon and
					spotted Shane setting up a game of eight ball. “Hey,” he said as he grabbed a
					cue.</p>
<p class="body-text">“Hey. When are you getting your lazy ass back to work?”</p>
<p class="body-text">Despite the rude words, Cole noticed the look of concern that
					Shane shot him. He ignored it. “I’m part-time at the ranch now. It won’t be
					long.”</p>
<p class="body-text">“Yeah?”</p>
<p class="body-text">“Definitely.”</p>
<p class="body-text">Shane watched him for another long moment. “Good,” he finally
					said. “Because I want my first-floor apartment back.”</p>
<p class="body-text">“The stairs too much for you, old man?”</p>
<p class="body-text">“You’re one to talk.” He gestured toward the table. “You want
					to break?”</p>
<p class="body-text">“Was that a joke about my leg?” Cole asked, but he was
					immediately distracted by the door of the saloon opening. The flash of daylight
					obscured the person, but as soon as it closed, he saw it was a blonde. No
					black-and-purple hair in sight.</p>
<p class="body-text">“You ready to play?” Shane asked.</p>
<p class="body-text">Yeah, he was ready to play, but he wasn’t thinking about pool.
					Instead he was thinking about his new neighbor.</p>
<p class="body-text">“Hey, did you hear the news?”</p>
<p class="body-text">Assuming Shane was talking about Grace, Cole just raised an
					eyebrow and leaned over the table to break.</p>
<p class="body-text">“There’s a big film production coming to town.”</p>
<p class="body-text">Cole forced himself to pull the cue back as if those words
					didn’t affect him. In fact, he managed to sink two balls with a perfect
					break.</p>
<p class="body-text">“You know anything about it?” Shane asked.</p>
<p class="body-text">“Why would I?”</p>
<p class="body-text">“I thought maybe you were going to go Hollywood again.”</p>
<p class="body-text">Cole forced himself to smile, even though his mind was
					spinning. That couldn’t be why Grace was here, could it? “That was a long time
					ago,” he said calmly.</p>
<p class="body-text">“Not that long ago,” Shane countered. “Ten years?”</p>
<p class="body-text">“Thirteen,” Cole said. Thirteen long years, but not even close
					to long enough. Thirteen years since Hollywood had come to town and he’d jumped
					in feetfirst. If Grace was part of that crowd…</p>
<p class="body-text">But no. She was renting an apartment, not staying at one of the
					fancy resorts. Grace wasn’t part of the film team. No way. But maybe this was a
					warning that should be heeded. A reminder that city girls had led him astray
					before. And he’d followed willingly.</p>
<p class="body-text">This chick was bad news. And she was living across the hall.
					And he wasn’t the least bit inclined to avoid her.</p>
<p class="body-text">She should’ve scared the hell out of him, and instead, he was
					smiling in anticipation.</p>
<p class="body-text">Somehow that only made him smile harder.</p>
<p class="body-text">Bad news, indeed.</p>
<p class="Basic-Paragraph-15"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter_One.vue?1240718e